import { Button } from "@/components/ui/baseUi/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/baseUi/dropdown-menu"
import { cn } from "@/modules/lib/utils"
import { FeatureKeys } from "@modules/featureToggle/featureToggleTypes"
import { useFeatureToggle } from "@modules/featureToggle/hooks/useFeatureToggle"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { getLanguageInfos } from "@modules/language/languageUtils"
import { Language } from "@modules/language/utils/languageUtils"
import { ChevronDown } from "lucide-react"

type Props = {
  onChange: (language: Language) => void
  selectedLanguage?: Language
  longValues?: boolean
}

export const LanguageDropdown: React.FC<Props> = ({ onChange, selectedLanguage, longValues }) => {
  const language = useLanguage()
  const allLanguagesAvailable = useFeatureToggle(FeatureKeys.AllLanguages)

  const languages = getLanguageInfos(allLanguagesAvailable).map((it) => ({
    label: longValues ? `${it.name} (${it.country.name})` : `${it.name} (${it.country.shortName})`,
    value: it.value,
    selected: longValues ? `${it.name} (${it.country.shortName})` : `${it.country.shortName}`,
  }))

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="outline" className="group justify-between focus-visible:ring-0">
            {languages.find((it) => it.value === (selectedLanguage ?? language))?.selected}
            <ChevronDown color="currentColor" className="w-3.5 group-data-[state=open]:rotate-180" />
          </Button>
        }
      />

      <DropdownMenuContent className="max-h-50 border-none p-0 shadow-2xl" align="start">
        {languages.map((it) => (
          <DropdownMenuItem
            key={it.value}
            onClick={() => onChange(it.value)}
            className={cn(
              "transition-duration-150 w-full cursor-pointer px-4 py-3 transition-colors hover:bg-neutral-100",
              { "bg-neutral-100": it.value === language },
            )}
          >
            {it.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
